import * as SwitchPrimitives from '@radix-ui/react-switch';
import * as React from 'react';

import { cn } from '@/lib/utils/cn';

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      'peer inline-flex shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-[0.4] data-[state=checked]:bg-blue-1 data-[state=checked]:hover:bg-blue-1-hover data-[state=unchecked]:bg-border data-[state=unchecked]:hover:bg-disableText bg-border disabled:bg-disableBg disabled:hover:bg-disableBg w-[2.125rem] h-5',
      className
    )}
    {...props}
    ref={ref}
    dir='ltr'
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block w-4 h-4 rounded-full bg-white shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-3.5 data-[state=unchecked]:translate-x-0 flex-shrink-0 rectangle'
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
